// Hinweis-Widget (warn/bad) mit optionalem × zum Schließen — für bleibende Hinweise wie
// „Lokales Speichern fehlgeschlagen“ oder fehlende Beweismittel (Handoff Übergabe §4).
import type { ReactNode } from 'react';
import { WarningCircle, X } from '@phosphor-icons/react';

export function HinweisWidget({ ton, titel, children, onSchliessen }: {
  ton: 'warn' | 'bad';
  titel?: ReactNode;
  children?: ReactNode;
  onSchliessen?: () => void;
}) {
  const farbe = ton === 'bad' ? 'var(--bad)' : 'var(--warn)';
  return (
    <div role="alert" className="flex items-start" style={{ gap: 12, padding: '14px 12px 14px 16px', borderRadius: 22,
      background: ton === 'bad' ? 'var(--bad-soft)' : 'var(--warn-soft)', boxShadow: `inset 0 0 0 1px color-mix(in srgb, ${farbe} 30%, transparent)` }}>
      <WarningCircle size={20} weight="fill" color={farbe} className="mt-[1px] shrink-0" />
      <div className="flex min-w-0 flex-1 flex-col" style={{ gap: 3 }}>
        {titel && <span style={{ fontSize: 14, fontWeight: 800, color: farbe, lineHeight: 1.4 }}>{titel}</span>}
        {children && <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink2)', lineHeight: 1.45 }}>{children}</span>}
      </div>
      {onSchliessen && (
        <button type="button" onClick={onSchliessen} aria-label="Hinweis schließen" data-tip="Schließen" className="inline-flex shrink-0 items-center justify-center"
          style={{ width: 36, height: 36, borderRadius: '50%', border: 'none', cursor: 'pointer', background: 'transparent', color: farbe }}>
          <X size={15} weight="bold" />
        </button>
      )}
    </div>
  );
}
